module.exports = __webpack_public_path__ + "f1728871edcecbfe7621917640b437eb.png";